define(function () {
    function Scroll() {
        var privates = {};
        var publics = {};

        privates.scrollEndDelay = 1000;
        privates.throttleDelay = 200;
        privates.scrollEndTimeout = false;
        privates.events = {};
        privates.win = false;

        publics.scrolltop = 0;
        publics.winHeight = 0;

        privates.init = function () {
            privates.win = $(window);
            privates.setEvents();
        };

        privates.eventData = function () {
            publics.scrolltop = privates.win.scrollTop();
            publics.winHeight = privates.win.height();
            return JSON.parse(JSON.stringify(publics));
        };

        privates.setEvents = function () {
            /* scroll start and end */
            window.addEventListener('scroll', function () {
                if (privates.scrollEndTimeout) {
                    clearTimeout(privates.scrollEndTimeout);
                } else {
                    publics.trigger('start');
                }

                privates.scrollEndTimeout = setTimeout(function () {
                    publics.trigger('end');
                    privates.scrollEndTimeout = false;
                }, privates.scrollEndDelay);
            });

            /* change - throttled */
            window.addEventListener(
                'scroll',
                _.throttle(function () {
                    publics.trigger('change');
                }, privates.throttleDelay)
            );
        };

        publics.on = function (event, cb) {
            privates.events[event] = privates.events[event] || [];
            privates.events[event].push(cb);
        };

        publics.trigger = function (event) {
            if (!privates.events[event]) return false;

            var data = privates.eventData();

            $.each(privates.events[event], function (key, cb) {
                if (_.isFunction(cb)) {
                    cb(data);
                }
            });
        };

        privates.init();

        return publics;
    }

    return new Scroll();
});
